import React, { useState } from 'react'
import { PreviewPromoMaterial } from 'api/ClientArea/PreviewPromoMaterials'
import { FormSubmitValues } from 'utils/formValidation'

import { NameDto } from '../../../api/Common/Types'
import {
  CreatePromoMaterialValues,
  PromoMaterialForm,
  UpdatePromoMaterialValues,
} from './PromoMaterialForm'

interface OuterProps {
  caLanguages: NameDto<string>[]
  sizes: NameDto[]
  promoMaterialsPreview: PreviewPromoMaterial[]
  onSubmit(
    values: FormSubmitValues<UpdatePromoMaterialValues | CreatePromoMaterialValues>
  ): Promise<void>
  onValidate?(
    values: FormSubmitValues<CreatePromoMaterialValues[] | UpdatePromoMaterialValues[]>
  ): Promise<PreviewPromoMaterial[] | undefined>
}

export const PromoMaterialSaveForm: React.FC<OuterProps> = (props) => {
  const isNew = true
  const [isEdit, setEdit] = useState<boolean>(isNew)

  const { promoMaterialsPreview } = props
  const [promoMaterialPreview] = promoMaterialsPreview
  return (
    <PromoMaterialForm
      {...props}
      promoMaterialPreview={promoMaterialPreview}
      isNew={isNew}
      isEdit={isEdit}
      setEdit={setEdit}
    />
  )
}
